import axios from "axios";

const requestCache = new Map();

import { RefreshSessionInterceptor } from "./interceptors/refreshSessionInterceptor";
import { mapResponse } from "./interceptors/mapResponse";
import { setAuthToken } from "./interceptors/setAuthToken";

const headers = {
  "Content-Type": "application/json",
};

class Http {
  constructor() {
    this.instance = Http.createInstance({
      baseURL: `${Http.api.common}/${Http.versions.v1}${this.getURLScope()}`,
      headers,
    });
    this.instance.interceptors.request.use((req) =>
      setAuthToken(req, requestCache),
    );
    this.instance.interceptors.response.use(
      (res) => mapResponse(res, requestCache),
      (err) => RefreshSessionInterceptor(err, requestCache),
    );
  }

  static createInstance() {
    return axios.create.apply(axios, arguments);
  }

  getURLScope() {
    return "";
  }

  get() {
    return this.instance.get.apply(this.instance, arguments);
  }

  patch() {
    return this.instance.patch.apply(this.instance, arguments);
  }

  put() {
    return this.instance.put.apply(this.instance, arguments);
  }

  post() {
    return this.instance.post.apply(this.instance, arguments);
  }

  delete() {
    return this.instance.delete.apply(this.instance, arguments);
  }
}

Http.api = {
  common: import.meta.env.VITE_APP_BASE_URL,
};

Http.versions = {
  v1: import.meta.env.VITE_APP_API_VERSION,
};

Http.$displayName = "Http";

export default Http;
